export enum SignInStates {
    Default = 'DEFAULT',
    Disabled = 'USER_DISABLED',
    Locked = 'USER_LOCKED'
}
